import React from "react";
import Pricing2 from "./PricingComponents/Pricing2";
import Expert from "./PricingComponents/Pricing33";
import ResNavbar from "../../Navbar/ResNavbar";
import Footer from "../../Footer/Footer/Blackfooter";

function CardsPage() {
    return (
        <>
            <ResNavbar />
            <Pricing2 />
            <Expert />
            <Footer />
        </>
    )
}
export default CardsPage;